module.exports = __webpack_public_path__ + "assets/img/page2-first-tab-neutral-07db5f07.png";